module.exports = __webpack_public_path__ + "static/media/congress_cover_en.0f8f1942.png";